@if (isUserLoggedIn) {
@if(showCollaborationPage) {
<app-collaboration></app-collaboration>
} @else {
<app-notification-settings-page></app-notification-settings-page>
}
} @else if(isRequiredDetailsNotPresent){
<app-no-required-date></app-no-required-date>
}